import { PromotionResponseDto, Reward, Trigger } from '@tiendanube/common';
import { LimitScopeTypes } from '@tiendanube/common/src/domains/marketing/promotions/LimitScopeTypes';
import { PromotionDiscountTypes } from '@tiendanube/common/src/domains/marketing/promotions/PromotionDiscountTypes';
import { PromotionTypes } from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { addMounthsToday, getTodayIsoString } from 'commons/utils/date';
import { Scope } from 'domains/Marketing/enums';

export const promotionDefault: PromotionResponseDto = {
  name: '',
  promotionType: PromotionTypes.BUY_X_PAY_Y,
  scopeType: Scope.ALL,
  categories: [],
  products: [],
  discountForQuantity: false,
  rewards: [],
  progressiveDiscounts: [{ quantity: 0, discount: 0 }],
  buyXPayY: null,
  dateType: 'unlimited',
  startDate: getTodayIsoString(),
  endDate: addMounthsToday(1),
  combinesWithOtherDiscounts: true,
  percentageOffDiscount: 0,
  paymentOptionsScopeType: LimitScopeTypes.UNLIMITED,
  paymentOptions: [],
};

export const CROSS_SELLING_DEFAULT_REWARD_VALUES = {
  scope_type: Scope.PRODUCTS,
  discount_type: PromotionDiscountTypes.PERCENTAGE,
  max_quantity: 1,
};

export const CROSS_SELLING_DEFAULT_TRIGGER: Trigger = {
  scope_type: Scope.ALL,
  scope_value: null,
  min_quantity: 1,
};

export const CROSS_SELLING_DEFAULT_REWARD: Reward = {
  ...CROSS_SELLING_DEFAULT_REWARD_VALUES,
  scope_value: [],
  discount_value: 0,
  triggers: [CROSS_SELLING_DEFAULT_TRIGGER],
};

export const promotionCrossSellingDefault: PromotionResponseDto = {
  ...promotionDefault,
  promotionType: PromotionTypes.CROSS_SELLING,
  rewards: [CROSS_SELLING_DEFAULT_REWARD],
};

export const promotionProgressiveDiscountDefault: PromotionResponseDto = {
  ...promotionDefault,
  promotionType: PromotionTypes.PROGRESSIVE_DISCOUNT,
  discountForQuantity: true,
};

export const promotionPercentageOffDefault: PromotionResponseDto = {
  ...promotionDefault,
  promotionType: PromotionTypes.PERCENTAGE_OFF,
};
